<template>
  <p
    v-if="showHeaderAndPrice"
    class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-mb-6"
  >
    {{ $t('item') }}
  </p>
  <div
    class="tw-border-2 mod-global--border-radius tw-mb-6 tw-bg-dark-3 tw-border-dark-1"
  >
    <div
      class="tw-flex tw-items-center tw-space-x-2 tw-px-4"
      :class="showHeaderAndPrice ? 'tw-pt-4' : 'tw-py-4'"
    >
      <img
        :src="mod.logo.thumb_320x180"
        :alt="`${mod.name} logo`"
        class="tw-w-20 tw-h-12 tw-shrink-0 tw-object-cover mod-global--border-radius"
      />
      <div>
        <p class="tw-font-bold mod-util-truncate-two-lines">
          {{ mod.name }}
        </p>
        <p class="tw-opacity-70">{{ gameName }}</p>
      </div>
    </div>
    <template v-if="showHeaderAndPrice">
      <div class="tw-px-5 tw-py-4">
        <base-divider class="tw-mb-3" />
        <div class="tw-flex tw-w-full tw-justify-between">
          <p class="tw-opacity-70">{{ $t('marketplace.price') }}</p>
          <p>
            <template v-if="usd">{{
              humanPriceFormat(mod.price_dollars)
            }}</template>
            <template v-else>
              {{ mod.price.toLocaleString() }} {{ tokenName }}
            </template>
          </p>
        </div>
      </div>
      <div
        v-if="usd"
        class="tw-px-5 tw-space-y-3 tw-py-4 tw-bg-dark tw-rounded-b-md"
      >
        <div class="tw-flex tw-w-full tw-justify-between">
          <p class="tw-opacity-70">{{ $t('marketplace.subtotal') }}</p>
          <p>{{ humanPriceFormat(mod.price_dollars) }}</p>
        </div>
        <div class="tw-flex tw-w-full tw-justify-between">
          <p class="tw-opacity-70">{{ $t('marketplace.taxes') }}</p>
          <p v-if="tax">{{ humanPriceFormat(convertToDecimal(tax)) }}</p>
          <p v-else>{{ $t('marketplace.calculated_at_checkout') }}</p>
        </div>
        <base-divider />
        <div class="tw-flex tw-w-full tw-justify-between">
          <p class="tw-font-bold">{{ $t('marketplace.total_due') }}</p>
          <p v-if="tax">
            {{ humanPriceFormat(convertToDecimal(tax + mod.price)) }}
          </p>
          <p v-else>{{ $t('marketplace.calculated_at_checkout') }}</p>
        </div>
      </div>
    </template>
  </div>
  <p v-if="tokenPack && usd && step !== PURCHASE_STEPS.RECEIPT" class="tw-mb-3">
    {{
      $t('marketplace.usd_ugc_license', {
        ugc: ugcName(null, true, true).value,
        count: tokenPack?.amount,
      })
    }}
  </p>
</template>

<script>
import { PURCHASE_STEPS } from '@config/options.js'
import { useResourceValue } from '@composables'
import {
  convertToDecimal,
  humanPriceFormat,
} from '@helpers/monetizationUtils.js'
export default {
  props: {
    mod: {
      type: Object,
      required: true,
    },
    usd: {
      type: Boolean,
      default: false,
    },
    gameName: {
      type: String,
      required: true,
    },
    tokenName: {
      type: String,
      required: true,
    },
    showHeaderAndPrice: {
      type: Boolean,
      default: true,
    },
    tokenPack: {
      type: Object,
      default: undefined,
    },
    tax: {
      type: Number,
      default: 0,
    },
    step: {
      type: String,
      default: PURCHASE_STEPS.CART,
    },
  },
  setup() {
    const { ugcName } = useResourceValue()
    return {
      convertToDecimal,
      humanPriceFormat,
      PURCHASE_STEPS,
      ugcName,
    }
  },
}
</script>
